// The Privacy Notice page body. The text is src/content/privacy.md, bundled as a
// string at build time and rendered by the same tiny safe markdown renderer as the
// Terms of Use: everything but headings, paragraphs, "-" lists and **bold** is escaped.

import { PRIVACY_MD, PRIVACY_VERSION } from '../core/privacy-text';
import { esc } from './ui';
import { termsBodyHtml } from './terms';

export { PRIVACY_VERSION };
export const PRIVACY_LINK_TEXT = 'Privacy Notice';

/** The notice as HTML. The title line and the "Version" line are left out: the page shows them itself. */
export function privacyBodyHtml(md: string = PRIVACY_MD) {
  return termsBodyHtml(md);
}

/** The version line shown above the notice. */
export function privacyMetaHtml() {
  return `<div class="terms-meta"><span class="muted">Version ${esc(PRIVACY_VERSION)}</span></div>`;
}
